var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HOW_TO_EARN_POINTS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import displayModal from 'root/src/client/logic/modal/actions/displayModal';
import { getUserDropEventLandingShortUrl, } from 'root/src/client/logic/dropEvent/thunks/getUserDropEventLandingShortUrl';
import creatorCampaignPointsLimitSelector from 'root/src/client/logic/app/selectors/creatorCampaignPointsLimitSelector';
import userCampaignDataSelector from 'root/src/client/logic/app/selectors/userCampaignDataSelector';
import platformIdSelector from 'root/src/client/logic/userData/selectors/platformIdSelector';
import dropEventSelector from 'root/src/client/logic/dropEvent/selectors/dropEventSelector';
import canEarnPointsSelector from 'root/src/client/logic/dropEvent/selectors/canEarnPointsSelector';
export const displayHowToEarnPointsModal = (params) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const dropEvent = dropEventSelector(state);
    const canEarnPoints = canEarnPointsSelector(state);
    const creatorCampaignPointsLimit = creatorCampaignPointsLimitSelector(state);
    const userCampaignData = userCampaignDataSelector(state);
    const platformId = platformIdSelector(state);
    const shortUrl = yield getUserDropEventLandingShortUrl(dropEvent.id)(dispatch, getState);
    dispatch(displayModal(HOW_TO_EARN_POINTS_MODAL_MODULE_ID, Object.assign(Object.assign({}, params), { shortUrl,
        userCampaignData,
        creatorCampaignPointsLimit,
        platformId,
        dropEvent,
        canEarnPoints, onClose: params === null || params === void 0 ? void 0 : params.onClose })));
});
